import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Spinner from '../common/Spinner';

const RequireConsent = ({ children }) => {
  const location = useLocation();
  const { consentLoading, loading, requiresConsent, user } = useAuth();

  if (loading || consentLoading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (requiresConsent) {
    return <Navigate to="/consent" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default RequireConsent;
